<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-row>
    <v-col cols="12">
      <h1>Новости</h1>
    </v-col>
    <v-col cols="12" sm="12">
      <v-row>
        <v-col>
          <template v-if="selected.length > 0">
            <v-btn class="mr-3" :disabled="selected.length === 0" outlined>Выбрано: {{ selected.length }}</v-btn>
            <v-menu offset-y left :disabled="selected.length === 0">
              <template v-slot:activator="{ on, attrs }">
                <v-btn outlined
                       :disabled="selected.length === 0"
                       class="pl-0 pr-0"
                       min-width="36"
                       v-bind="attrs"
                       v-on="on">
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="submitDialog = true; submitItem = null">
                  <v-list-item-title>Удалить</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
        </v-col>
        <v-col class="text-right">
          <v-btn @click="$router.push({ name: 'news-create'})">Создать</v-btn>
        </v-col>
      </v-row>
      <!--<v-row>-->
        <!--<v-col cols="6">-->
          <!--<v-text-field-->
                  <!--v-model="search"-->
                  <!--append-icon="mdi-magnify"-->
                  <!--label="Поиск"-->
                  <!--single-line-->
                  <!--otlined-->
                  <!--hide-details-->
          <!--&gt;</v-text-field>-->
        <!--</v-col>-->
      <!--</v-row>-->
      <v-data-table
              no-data-text="Нет новостей"
              no-results-text="По заданному запросу ничего не найдено"
              :headers="headers"
              :items="news"
              :header-props="{sortIcon: 'icon-custom-arrow'}"
              :search="search"
              :options.sync="options"
              :footer-props="footerProps"
              :loading="loading"
              :items-per-page="-1"
              loading-text="Загрузка новостей... Подождите пожалуйста"
      >
        <template v-slot:item.description="{ item }">
          {{ item.description.length > 100 ? item.description.substring(0, 100) + '...' : item.description}}
        </template>
        <template v-slot:item.actions="{ item }">
          <div class="text-right">
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                        small
                        class="mr-2"
                        v-bind="attrs"
                        v-on="on"
                >
                  mdi-dots-vertical
                </v-icon>
              </template>
              <v-list>
                <v-list-item @click="$router.push({ name: 'news-edit', params: { id: item.id } })">
                  <v-list-item-title>Редактировать</v-list-item-title>
                </v-list-item>
                <v-list-item @click="submitDialog = true; submitItem = item">
                  <v-list-item-title>Удалить</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </template>
      </v-data-table>
      <!--</v-card>-->
    </v-col>
    <v-overlay
            :z-index="4"
            :value="overlay"
    >
    </v-overlay>
    <v-dialog
            v-model="submitDialog"
            max-width="444"
    >
      <v-card>
        <v-card-title >
          Подтвердить действие
        </v-card-title>

        <v-card-actions>


          <v-btn
                  v-if="submitItem == null"
                  @click="submitDelete(submitItem); submitDialog = false">
            Да
          </v-btn>
          <v-btn
                  v-else
                  @click="submitDelete(submitItem); submitDialog = false">
            Да
          </v-btn>
          <v-btn
                  outlined
                  @click="submitDialog = false"
          >
            Нет
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
  // @ is an alias to /src

  import NewsService from './../../api/NewsService'
  export default {
    name: 'NewsIndex',
    components: {},
    data: () => ({
      submitDialog: false,
      submitItem: null,
      selected: [],
      filters: {
      },
      overlay: false,
      search: '',
      loading: true,
      categories: [],
      options: {},
      footerProps: {
        itemsPerPageText: 'Новостей на страницу',
        pageText: '{0}-{1} из {2}',
        itemsPerPageAllText: 'Все',
        itemsPerPageOptions: [-1]
      },
      total: 0,
      headers: [
        {
            text: 'Заголовок',
            value: 'name',
          sortable: false,
        },
        {
          text: 'Описание',
          value: 'description',
          sortable: false,
        },
        {
          text: 'Дата создания',
          value: 'created_at',
          sortable: false,
        },
        {text: 'Действия', value: 'actions', sortable: false, width: "5%"},
      ],
      news: [],
    }),
    mounted() {
      NewsService.getCategoryList().then(response => {
        this.categories = response.data
      });
    },
    watch: {
      options: {
        handler() {
          this.getDataFromApi()
        },
        deep: true,
      },
      search() {
        this.getDataFromApi()
      }
    },
    methods: {
      submitDelete(item = null){
        if(item){
          this.removeNews(item)
        } else {
          this.massDelete()
        }
      },
      collectSelectedId(){
        let ids = [];
        this.selected.forEach(function (item) {
          ids.push(item.id)
        })

        return ids;
      },
      massDelete(){
        let params = {
          ids: this.collectSelectedId()
        };

        NewsService.massEdit('delete', params).then(response => {
          this.getDataFromApi()
        })
      },
      removeNews(item){
        NewsService.remove(item.id).then(response => {
          this.loading = true
          this.getDataFromApi()
        })
      },
      getDataFromApi() {
        this.loading = true

        let params = {
          search: this.search,
        }
        NewsService.list(params)
          .then(response => {
            this.news = response.data
            this.loading = false
          })
      },
    }
  }
</script>

<style lang="scss" scoped>
  .v-btn--fab.v-size--x-small {
    width: 20px;
    height: 20px;

    .mdi::before {
      font-size: 12px;
    }
  }

  .filter-popup {
    position: absolute;
    width: 250px;
    z-index: 5;

    &:hover {
      cursor: auto;
    }

    &.v-card--link:focus::before {
      opacity: 0;
    }
  }
</style>
